module.exports = __webpack_public_path__ + "crm_static/img/15.abe467cf.png";